import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { TextLoca } from "../text/TextLoca";
export var LevelRequirement = function (_a) {
    var available = _a.available, required = _a.required;
    var className = available >= required ? IdStyles.TextPositive : IdStyles.TextNegative;
    var locaReplacements = new Map([[ReplacementLoca.zero_0, required.toString()]]);
    return (React.createElement("div", null,
        React.createElement(TextLoca, { className: className, id: IdLoca.stageX, replacements: locaReplacements })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/level-requirement/LevelRequirement.tsx
// module id = 2735
// module chunks = 3